// File: src/App.js
import React, { useEffect } from 'react';
import './App.css';

import Contact from './sections/Contact/Contact';
import Certificates from './sections/Certificates/Certificates';
import Projects from './sections/Projects/Projects';
import Experience from './sections/Experience/Experience';
import About from './sections/About/About';
import Home from './sections/Home/Home';
import AltitudeGauge from './components/AltitudeGauge/AltitudeGauge';
import { getPersonalInfo } from './data/usePortfolioData';

function App() {
  useEffect(() => {
    // Wait for all sections to render and then scroll to home
    const scrollToHome = () => {
      // Force a reflow to ensure all sections are rendered
      // eslint-disable-next-line no-unused-expressions
      document.body.offsetHeight; // Force reflow
      
      const home = document.getElementById('home');

      // Always scroll to home section, regardless of page scrollability
      if (home) {
        // Scroll immediately to prevent any flash of other sections
        home.scrollIntoView({ behavior: 'instant', block: 'start' });

        // Force scroll position to ensure we're at the right place
        window.scrollTo(0, home.offsetTop);

        setTimeout(() => {
          // Re-enable smooth scrolling after initial positioning
          document.documentElement.style.scrollBehavior = 'smooth';

          // Force a scroll event to ensure proper section detection
          window.dispatchEvent(new Event('scroll'));
        }, 50); // Reduced delay from 100ms to 50ms
      }
    };

    // Call immediately and also with a small delay to ensure it works
    scrollToHome();
    setTimeout(scrollToHome, 100); // Backup call with shorter delay
  }, []);

  const personalInfo = getPersonalInfo();

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:bg-space-blue-600 focus:text-white focus:px-4 focus:py-2 focus:rounded-lg"
      >
        Skip to content
      </a>

      <AltitudeGauge />

      <main id="main-content">
        <Contact />
        <Certificates />
        <Projects />
        <Experience />
        <About />
        <Home />
      </main>

      <footer className="bg-black/40 backdrop-blur-md text-gray-300 py-6 px-4 text-center border-t border-white/10">
        <p className="text-sm">
          © {new Date().getFullYear()} {personalInfo.name}
        </p>
        <div className="mt-2 flex items-center justify-center gap-4 text-sm">
          <a
            href={personalInfo.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-space-blue-300 hover:text-white transition-colors duration-300"
          >
            LinkedIn
          </a>
          <a
            href={personalInfo.github}
            target="_blank"
            rel="noopener noreferrer"
            className="text-space-blue-300 hover:text-white transition-colors duration-300"
          >
            GitHub
          </a>
        </div>
      </footer>
    </>
  );
}

export default App;